import styled from "styled-components"

export const ScheduleItemWrapper = styled.div`
  --icon-width: 34px;
  --icon-margin-right: 8px;

  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 6px 0px;
  border-bottom: 0.8px solid
    var(--Schemes-Outline-Variant, rgba(0, 38, 58, 0.14));
  cursor: default;
`

export const ScheduleItemInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1 1 0;
  width: calc(100% - var(--icon-width) - var(--icon-margin-right));
`

export const MealName = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: 17px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const CaloriesBox = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
  color: var(--Schemes-On-Surface-Variant-2, #69757d);
  font-size: 12px;
  font-weight: 500;
  line-height: 15px;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  margin: 0;
`

export const MealNutrient = styled.p`
  letter-spacing: 0.12px;
  flex-shrink: 0;
  height: 15px;
  line-height: 15px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  margin: 0;
`

export const SchedulePeriod = styled.div`
  display: flex;
  align-items: center;
  height: 22px;
  line-height: 17px;
  color: var(--Schemes-On-Surface-Variant, #576066);
`

export const SmallWeekDayOption = styled.div<{ $isSelected: boolean }>`
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  border-radius: 17px;
  font-weight: 700;
  line-height: 160%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 10px;

  border: ${({ $isSelected }) =>
    `1px solid ${
      $isSelected
        ? "var(--Primary_16, rgba(13, 163, 186, 0.16))"
        : "transparent"
    }`};

  background: ${({ $isSelected }) =>
    $isSelected
      ? "rgba(13, 163, 186, 0.08)"
      : "var(--Schemes-Surface-Container, #EBEDF0)"};
  color: ${({ $isSelected }) =>
    $isSelected
      ? "var(--Schemes-Primary-Container-Variant-2, #0FBDD4)"
      : "var(--Schemes-Outline, rgba(0, 38, 58, 0.32))"};
`

export const FoodImageBox = styled.div`
  height: 34px;
  width: 34px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--Schemes-Primary-Container-Variant, #cceded);
  flex-shrink: 0;
  overflow: hidden;
  border-radius: 8px;
`
